import { Paths } from './url_helpers';

export type SignupSigninSource = 'ArtistShopFavorite' |
'BuyItNowButton' |
'Cart' |
'CheckoutLayout' |
'ClaimOrderBanner' |
'DigitalDownload' |
'FavoriteButton' |
'FavoriteShop' |
'GiftCards' |
'Offer' |
'PriceGuideTool' |
'ProductReview' |
'ReverbHeader' |
'WatchBadge' |
'AddToCollectionCallout';

export function redirectToSignup(source: SignupSigninSource, redirectTo?: string): void {
  const redirectUrl = redirectTo ?? window.location.href;
  window.location.assign(signupUrl(source, redirectUrl));
}

export function signupUrl(source: SignupSigninSource, redirectTo: string): string {
  return Paths.signUp.expand({ redirect_source: source, redirect_to: redirectTo });
}

export function redirectToSignin(source: SignupSigninSource, redirectTo?: string): void {
  const redirectUrl = redirectTo ?? window.location.href;
  window.location.assign(signinUrl(source, redirectUrl));
}

export function signinUrl(source: SignupSigninSource, redirectTo: string): string {
  return Paths.signIn.expand({ redirect_source: source, redirect_to: redirectTo });
}
